import { render, staticRenderFns } from "./ServingSizes.vue?vue&type=template&id=abbfdbd4&"
import script from "./ServingSizes.vue?vue&type=script&lang=js&"
export * from "./ServingSizes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports